import React from "react";
import {useNavigate} from "react-router-dom";

import {ConfirmationModal} from "../../../confirmationModal/ConfirmationModal";
import {useAppDispatch} from "../../../../../app/hooks";
import {deleteFranchise} from "../../../../modules/franchise/franchiseSlice";
import {showErrorToastNotification, showInfoToastNotification, showSuccessToastNotification} from "../../../toastNotification/toastNotificationSlice";

interface ConfirmationModalProps {
    publicId: string
    handleClose: (value?: any) => any
    onClickRedirectPath?: string
    entityName?: string
}

export const DeleteFranchiseConfirmationModal: React.FC<ConfirmationModalProps> = ({
                                                                                       publicId,
                                                                                       handleClose,
                                                                                       onClickRedirectPath,
                                                                                       entityName
                                                                                   }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const handleDelete = async () => {
        handleClose();
        if (onClickRedirectPath) {
            navigate(onClickRedirectPath);
        }
        dispatch(showInfoToastNotification({message: "Deleting franchise. We'll notify you once it's done."}));
        try {
            await dispatch(deleteFranchise(publicId)).unwrap();
            dispatch(showSuccessToastNotification({message: "Franchise deleted successfully"}));
        } catch {
            dispatch(showErrorToastNotification({message: "Failed to delete the franchise. Please try again."}));
        }
    };

    return <ConfirmationModal
        title={"Delete the franchise"}
        subtitle={"Are you sure you want to delete this franchise? You won't be able to undo this action."}
        closeButtonTitle={"No, cancel"}
        confirmButtonTitle={"Yes, delete"}
        onConfirm={handleDelete}
        onClose={handleClose}
        confirmationText={entityName}
    />
}
